<template>
    <div>
      <div class="pay_main_body_divC_main_div">
        <div class="pay_main_body_divC_main_div_divA">
          <div class="pay_main_body_divC_main_div_divA_div">
            <div class="pay_main_body_divC_main_div_divA_div_div_input">
              <div class="pay_main_body_divC_main_div_divA_div_div_input_div">
                <div class="package-container">
                  <button
                    class="package-button"
                    :class="{ active: selectedPackage === 'monthly' }"
                    @click="selectPackage('monthly')"
                  >
                    月套餐
                  </button>
                  <button
                    class="package-button"
                    :class="{ active: selectedPackage === 'bimonthly' }"
                    @click="selectPackage('bimonthly')"
                  >
                    双月套餐
                  </button>
                  <button
                    class="package-button"
                    :class="{ active: selectedPackage === 'quarterly' }"
                    @click="selectPackage('quarterly')"
                  >
                    季套餐
                  </button>
                </div>
              </div>
              <div class="input_5">
                <el-input
                  placeholder="请输入内容"
                  v-model="input3"
                  class="input-with-select"
                >
                  <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
              </div>
            </div>
            <div class="div_4">
              <div>
                <div class="duoxuan" v-for="list in gj_data" :key="list.lable">
                  <div>
                    <div class="H_qq">{{ list.lable }}</div>
                  </div>
                  <div>
                    <div style="text-align: left">
                      <a
                        class="a_text"
                        v-for="listins in list.datalist"
                        :key="listins.id"
                        @click.prevent="
                          toggleSelection(listins.gjname, listins.money)
                        "
                      >
                        <img
                          class="retop_img"
                          v-if="listins.img_show"
                          src="http://apiupss.ppfly.top/images/static_hot.png"
                          alt=""
                        />
                        <span class="a_texttype">
                          <input
                            class="input_duoxuan"
                            type="checkbox"
                            :id="listins.gjname"
                            v-model="selectedLabels"
                            :value="listins.gjname"
                            @change="
                              handleCheckboxChange(listins.gjname, listins.money)
                            "
                          />
                          {{ listins.gjname }}
                        </span></a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pay_main_body_divC_main_div_divB">
          <div class="pay_main_body_divC_main_div_divB_divB">
            <div class="pay_main_body_divC_main_div_divB_divB_div">
              <div class="pay_main_body_divC_main_div_divB_divB_div_div">
                <div class="pay_main_body_divC_main_div_divB_divB_div_div_top">
                  <div>购买详情</div>
                  <div>额度充值，静态单价低至五折！</div>
                </div>
                <div class="pay_div_div_inputs">
                  <div
                    class="div_inputs"
                    v-for="list in selectedLabelsdata"
                    :key="list.id"
                  >
                    <div>
                      <div>{{ list.gjname }}</div>
                    </div>
                    <div>
                      <div>￥{{ list.money }}/个</div>
                    </div>
                    <div>
                      <div class="jia_jian_div">
                        <div class="div_inputs_jian" @click="jianfa(list)">
                          <i class="el-icon-minus"></i>
                        </div>
                        <div class="div_inputs_input">{{ list.num }}</div>
                        <div class="div_inputs_jia" @click="janfa(list)">
                          <i class="el-icon-plus"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pay_div_div_nums">
                  <div>
                    <div @click="qingkong()">
                      <i class="el-icon-delete"></i>清空
                    </div>
                  </div>
                  <div>
                    <div>地区总数: {{ selectedLabelsdata.length }}</div>
                    <div>总IP数量: {{ totalQuantity }}</div>
                  </div>
                  <div>
                    <div>总价</div>
                    <div>￥ {{ totalPrice }}</div>
                  </div>
                  <div>

                    <div @click="openWeChatChat">立即购买</div>
                  </div>
                  <div>注：所有类型IP仅支持在境外环境下使用</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Head from "@/components/head/head.vue";
  import Footer from "@/components/footer/footer.vue";
  import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
  export default {
    name: "home",
    components: { Head, Footer, Xuanfuret },
    data() {
      return {
        IPsum: "",
        img_show: true,
        selectedLabels: [],
        selectedLabelsdata: [],
        selectedPackage: null,
        input3: "",
        dongtaibaoyue: false,
        jingtaizhuzhai: true,
        activeNames: "",
        isClickedA: false,
        isClickedB: false,
        isClickedC: false, // 用于跟踪按钮是否被点击
        edcz_div_show: false,
        cptc_div_show: true,
        gj_data: [
          {
            lable: "推荐地区",
            datalist: [
              { id: 1, gjname: "中国-香港", money: 70, img_show: true },
              { id: 2, gjname: "新加坡", money: 70, img_show: true },
              { id: 3, gjname: "越南-胡志明市", money: 70, img_show: true }
            ],
          },
          {
            lable: "亚太",
            datalist: [
              { id: 12, gjname: "中国-香港", money: 70 },
              { id: 13, gjname: "韩国-首尔", money: 70 },
              { id: 14, gjname: "泰国-曼谷", money: 70 },
              { id: 15, gjname: "新加坡", money: 70, img_show: true },
              { id: 16, gjname: "越南-胡志明市", money: 70 },
              { id: 17, gjname: "马来西亚-吉隆坡", money: 70 },
              { id: 18, gjname: "菲律宾-马尼拉", money: 70 },
              { id: 19, gjname: "越南-河内", money: 70 },
              { id: 20, gjname: "印度-德里", money: 70, img_show: true },
              { id: 21, gjname: "日本-丰田", money: 70 },
              { id: 22, gjname: "中国-台湾", money: 70 },
              { id: 23, gjname: "日本-东京", money: 70 },
              { id: 24, gjname: "印尼-雅加达", money: 70 },
              { id: 25, gjname: "澳大利亚-悉尼", money: 70 },
              { id: 26, gjname: "孟加拉国-达卡", money: 70 },
              { id: 27, gjname: "约旦-安曼", money: 70 },
              { id: 28, gjname: "科威特", money: 70, img_show: true },
              { id: 29, gjname: "日本-大阪", money: 70 },
              { id: 30, gjname: "伊拉克-巴格达", money: 70 },
            ],
          },

          {
            lable: "欧洲与美洲",
            datalist: [
              { id: 40, gjname: "美国-华盛顿", money: 70, img_show: true },
              { id: 41, gjname: "加拿大", money: 70, img_show: true },
              { id: 42, gjname: "美国-加利福尼亚", money: 70 },
              { id: 43, gjname: "法国", money: 70 },
              { id: 44, gjname: "德国-法兰克福", money: 70 },
              { id: 45, gjname: "意大利", money: 70 },
              { id: 46, gjname: "美国-洛杉矶", money: 70, img_show: true },
              { id: 47, gjname: "法国-巴黎", money: 70 },
              { id: 48, gjname: "英国-伦敦", money: 70 },
              { id: 49, gjname: "俄罗斯-莫斯科", money: 70 },
              { id: 50, gjname: "西班牙-巴塞罗那", money: 70 },
              { id: 51, gjname: "墨西哥", money: 70 },
              { id: 52, gjname: "美国-圣何塞", money: 70 },
              { id: 53, gjname: "巴西-圣保罗", money: 70 },
              { id: 54, gjname: "美国-西雅图", money: 70, img_show: true },
              { id: 55, gjname: "美国-迈阿密", money: 70, img_show: true },
              { id: 56, gjname: "美国-纽约", money: 70 },
              { id: 57, gjname: "美国-芝加哥", money: 70 },
              { id: 58, gjname: "波兰-华沙", money: 70 },
              { id: 59, gjname: "奥地利-维也纳", money: 70, img_show: true },
              { id: 60, gjname: "丹麦-斯基沃", money: 70 },
              { id: 61, gjname: "瑞典-斯德哥尔摩", money: 70 },
            ],
          },

          {
            lable: "中东",
            datalist: [
              { id: 74, gjname: "迪拜", money: 70 },
            ],
          }
        ],
      };
    },
    computed: {
      totalPrice() {
        // 计算总价
        return this.selectedLabelsdata.reduce((total, item) => {
          return total + item.money * item.num;
        }, 0);
      },
      totalQuantity() {
        // 计算总数量
        return this.selectedLabelsdata.reduce((total, item) => {
          return total + item.num;
        }, 0);
      },
      buttonStyleA() {
        return {
          backgroundColor: this.isClickedA ? "#91322f" : "#fff", // 背景颜色
          color: this.isClickedA ? "white" : "black", // 字体颜色
        };
      },
      buttonStyleB() {
        return {
          backgroundColor: this.isClickedB ? "#91322f" : "#fff", // 背景颜色
          color: this.isClickedB ? "white" : "black", // 字体颜色
        };
      },
      buttonStyleC() {
        return {
          backgroundColor: this.isClickedC ? "#91322f" : "#fff", // 背景颜色
          color: this.isClickedC ? "white" : "black", // 字体颜色
        };
      },
    },
    mounted() {},
    created() {

      // 在组件创建时获取路由参数
      // this.userId = this.$route.params.id;
      let types = this.$route.query.lable;
      if (types == "额度充值") {
        this.edcz_div_show = true;
        this.cptc_div_show = false;
      } else if (types == "产品套餐") {
        this.edcz_div_show = false;
        this.cptc_div_show = true;
      }
    },
    beforeDestroy() {},
    methods: {
      openWeChatChat() {
    },
      toggleSelection(gjname, money) {
        var datalist = {
          gjname: gjname,
          money: money,
          num: 1,
        };

        const index = this.selectedLabels.indexOf(gjname);
        if (index === -1) {
          // 如果未选中，则添加到数组
          this.selectedLabels.push(gjname);
          this.selectedLabelsdata.push(datalist);
          console.log(this.selectedLabelsdata);
        } else {
          // 如果已选中，则从数组中移除
          this.selectedLabels.splice(index, 1);
          this.selectedLabelsdata.splice(index, 1);
          console.log(this.selectedLabelsdata);
        }
      },
      selectPackage(packageType) {
        // monthly bimonthly quarterly
        if (packageType == "monthly") {
          this.selectedLabelsdata.forEach((item) => {
            item.money = 10;
          });

          this.gj_data.forEach(group => {
          group.datalist.forEach(item => {
            item.money = 10;
          });
        });
        }else if(packageType == "bimonthly"){
          this.selectedLabelsdata.forEach((item) => {
            item.money = 18;
          });

          this.gj_data.forEach(group => {
          group.datalist.forEach(item => {
            item.money = 18;
          });
        });
        }else if(packageType == "quarterly"){
          this.selectedLabelsdata.forEach((item) => {
            item.money = 25;
          });

          this.gj_data.forEach(group => {
          group.datalist.forEach(item => {
            item.money = 25;
          });
        });
        }
        this.selectedPackage = packageType; // 设置选中的套餐
        console.log(this.selectedLabelsdata);
        console.log(this.selectedLabels);
      },
      handleChange() {},
      qingkong() {
        this.selectedLabelsdata = [];
        this.selectedLabels = [];
      },
      jianfa(data) {
        console.log(data.gjname);
        data.num = data.num - 1;
        if (data.num < 1) {
          console.log("删除");
          this.removeItem(data.gjname);
        }
        // selectedLabelsdata
      },
      janfa(data) {
        data.num = data.num + 1;
      },
      removeItem(gjname) {
        // 使用 filter 方法删除指定 gjname 的对象
        this.selectedLabelsdata = this.selectedLabelsdata.filter(
          (item) => item.gjname !== gjname
        );
        this.selectedLabels = this.selectedLabels.filter(
          (item) => item !== gjname
        );
      },
      changeStyleA() {
        this.dongtaibaoyue = true;
        this.jingtaizhuzhai = false;
        this.isClickedA = !this.isClickedA; // 切换点击状态
        this.isClickedB = false;
        this.isClickedC = false;
      },
      changeStyleB() {
        this.jingtaizhuzhai = true;
        this.dongtaibaoyue = false;
        this.isClickedB = !this.isClickedB; // 切换点击状态
        this.isClickedA = false;
        this.isClickedC = false;
      },
      changeStyleC() {
        this.dongtaibaoyue = false;
        this.jingtaizhuzhai = false;
        this.isClickedC = !this.isClickedC; // 切换点击状态
        this.isClickedB = false;
        this.isClickedA = false;
      },

      onqiehuan() {
        this.edcz_div_show = true;
        this.cptc_div_show = false;
      },
      onqiehuanB() {
        this.cptc_div_show = true;
        this.edcz_div_show = false;
      },
    },
  };
  </script>
    <style scoped>
  .home_H {
    position: relative;
  }
  .el-icon-circle-close {
    font-size: 30px;
    color: #edf3fc;
  }

  .el-icon-arrow-down,
  .el-icon-user {
    font-weight: 600;
  }

  .el-header,
  .el-footer {
    color: #333;
    text-align: center;
    line-height: 60px;
    padding: 0;
  }

  .el-header {
    position: sticky;
    top: 0;
    background-color: #edf3fc;
    z-index: 5;
  }

  .imgstop_text {
    display: flex;
    justify-self: center;
    font-size: 25px;
    font-weight: 550;
    background-color: #edf3fc;
    width: 500px;
    margin: 0 auto;
  }
  .imgstop {
    width: 100%;
    height: 50px;
    background-image: url("../../assets/tops.png");
    background-size: cover;
  }

  .imgstop > div div {
    color: #f15a24;
  }

  .imgstop_text {
    display: flex;
    justify-self: center;
    font-size: 25px;
    font-weight: 550;
    background-color: #edf3fc;
    width: 500px;
    margin: 0 auto;
  }
  .pay_main_body_divA_div_H {
    font-size: 38px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    text-align: center;
    color: #1b2336;
    margin-top: 50px;
  }
  .pay_main_body_divA_div_text {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba(27, 35, 54, 0.68);
    position: relative;
    width: max-content;
    margin: 16px auto 0;
  }
  .pay_main_body_divA_div_text_butts_divA {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 113px;
    height: 32px;
    z-index: 11;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #1b2336;
    cursor: pointer;
    position: relative;
    border-radius: 20px;
    line-height: 32px;
  }
  .pay_main_body_divA_div_text_butts_divB {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 113px;
    height: 32px;
    z-index: 11;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #1b2336;
    cursor: pointer;
    position: relative;
    border-radius: 20px;
    line-height: 32px;
  }
  .pay_main_body_divA_div_text_butts {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .pay_img_textA {
    display: flex;
    justify-content: space-between;
    width: 700px;
  }
  .pay_img_textA > div {
    letter-spacing: 1px;
    margin-left: 7px;
    font-size: 14px;
    color: #100043;
  }
  .pay_img_textA_img {
    margin-top: 5px;
  }
  .pay__div_img_textA {
    margin-top: 50px;
    display: flex;
    justify-content: center;
  }
  .div_jiajian_butt {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .div_jiajian_buttB {
    display: flex;
    justify-content: left;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .div_jiajian_butt_text {
    border: none;
    background: transparent;
    font-size: 40px;
    line-height: 52px;
    height: 52px;
    font-weight: 600;
    color: #240009;
    padding-left: 20px;
    padding-right: 20px;
  }
  .div_jiajian_butt_textB {
    border: none;
    background: transparent;
    font-size: 40px;
    line-height: 52px;
    height: 52px;
    font-weight: 600;
    color: #240009;
    /* padding-left: 20px; */
    padding-right: 20px;
    text-align: left;
  }
  .div_jiajian_butt_A {
    width: 40px;
    height: 40px;
    margin-top: 5px;
  }
  .div_jiajian_butt_B {
    width: 40px;
    height: 40px;
    margin-top: 5px;
  }
  .pay_main_body_divB {
    margin-top: 100px;
  }
  .pay_main_body_divB_div_div_div {
    width: 262px;
    /* height: 480px; */
    padding-right: 20px;
    padding-left: 20px;
  }

  .pay_main_body_divB_div_div_div:hover .div_jiajian_butt_text {
    color: #d45f1b;
  }
  .pay_main_body_divB_div_div_div_yhgm {
    transition: 0.4s;
    height: 52px;
    background: linear-gradient(90deg, #ffbe5c, #ff5a36);
    box-shadow: 0 -2px 15px 0 #f3f3f3;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #f1f2f4;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #edf3fc;
    margin: 19px auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    z-index: 2;
  }
  .pay_main_body_divB_div_div_div_div_span {
    display: flex;
    justify-content: right;
  }
  .pay_main_body_divB_div_div_div_div_span > span {
    background-color: #6e2e04;
    color: #edf3fc;
    /* padding: 5px; */
    line-height: 20px;
    border-radius: 15px;
    font-size: 15px;
    padding-right: 10px;
    padding-left: 10px;
  }
  .pay_main_body_divB_div_div_div_div_text {
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #171a1f;
  }
  .pay_main_body_divB_div_div_div_div_textB {
    font-family: SourceHanSansCN-Medium;
    font-size: 20px;
    color: #171a1f;
    text-align: left;
  }
  .jcdj {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 1px;
  }
  .pay_main_body_divB_div_div {
    position: relative;
    /* min-height: 580px; */
    max-width: 1310px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    z-index: 0;
  }
  .pay_main_body_divB_div_divB {
    position: relative;
    /* min-height: 580px; */
    max-width: 1510px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    z-index: 0;
  }
  .dov_top {
    transition: 0.4s;
    padding-top: 20px;
  }
  .pay_main_body_divB_div_div_div:hover .dov_top {
    transform: translateY(-10px);
  }
  .pay_main_body_divB_div_div_div:hover .pay_main_body_divB_div_div_div_yhgm {
    background: linear-gradient(90deg, #ffffff, #ffffff);
    color: #ff5a36;
    border: 1px solid #ff5a36;
  }
  .pay_main_body_divC_div {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    position: relative;
    /* min-height: 580px; */
    max-width: 1480px;
    margin: 0 auto;
    z-index: 0;
    padding-right: 200px;
  }
  .pay_main_body_divC_div_ {
    width: 226px;
    display: flex;
    justify-content: center;
    margin-top: 15px;
    cursor: pointer;
    position: relative;
  }
  .pay_main_body_divC_div_div:nth-child(odd) {
    color: #ff6c01;
  }
  .pay_main_body_divC_div_ > div:nth-child(1) {
    width: 80%;
    font-size: 14px;
  }
  .pay_main_body_divC_div_ > div:nth-child(2) {
    width: 20%;
    font-size: 14px;
    text-align: right;
    white-space: nowrap;
    text-decoration: line-through; /* 添加删除线 */
  }
  .pay_main_body_divC_div_div {
    display: flex;
    justify-content: space-between;
  }
  .pay_main_body_divC_div_div:hover .div_li_showB {
    opacity: 1;
    width: 150px;
    transition: 0.4s;
  }
  .pay_main_body_divC_div_div:hover {
    color: #ff6c01;
  }
  .pay_main_body_divC_div_div:hover .pay_main_body_divC_div_div_let {
    color: #ff6c01;
  }
  .pay_main_body_divC_div_div:hover .el-icon-caret-right {
    color: #ff6c01;
    opacity: 1;
  }

  .el-icon-caret-right {
    display: flex;
  }
  .pay_main_body_divC_div_div_let {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    width: 150px;
    text-align: left;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #170f49;
    display: flex;
    align-items: center;
  }
  .el-icon-caret-right {
    opacity: 0;
  }
  .div_li_showB {
    display: flex;
    justify-content: center;
    opacity: 0;
    font-size: 12px;
    width: 0px;
    border: 1px solid #ff6c01;
    border-radius: 15px;
    position: absolute;
    left: 140px;
    background-color: #edf3fc;
    color: #ff6c01;
  }
  .pay_main_body_divD_div {
    display: flex;
    justify-content: center;
  }
  .pay_main_body_divD_div_div {
    width: 1328px;
    height: 185px;
    display: flex;
    justify-content: space-around;
    background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);
    padding: 30px;
    border-radius: 25px;
    margin-top: 100px;
  }
  .pay_main_body_divD_div_div_div_img {
    display: flex;
    justify-content: center;
    margin-top: 35px;
  }
  .but_div_ljdz > div {
    margin: 0 auto;
  }
  .but_div_ljdz {
    width: 174px;
    height: 50px;
    display: flex;
    align-items: center;
    color: #edf3fc;
    background: linear-gradient(90deg, #ffbe5c, #ff5a36);
    font-family: SourceHanSansCN-Regular;
    font-weight: 600;
    font-size: 17px;
    box-shadow: 0 4px 5.3px 0 rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    margin-top: 70px;
  }
  .dingzhi1V1 {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-right: 40px;
  }

  .dztc_text {
    font-family: SourceHanSansCN-Regular;
    font-weight: 600;
    font-size: 31px;
    color: #14171a;
    margin-left: 37px;
    margin-top: 40px;
  }
  .dingzhi1V1 > div {
    margin-right: 20px;
  }
  .dingzhi1V1_text {
    text-align: left;
    margin: 20px;
    font-size: 14px;
  }
  .pay_main_body_divE {
    display: flex;
    justify-content: center;
    margin-top: 100px;
  }
  .pay_main_body_divE > div {
    width: 1400px;
  }
  .collapse_text {
    text-align: left;
    color: #3194ce;
  }
  .but_Htext {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 38px;
    color: #1b2336;
    text-align: center;
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .top_button_djd {
    width: max-content;
    height: 42px;
    border: 1px solid rgba(145, 50, 47, 0.18);
    border-radius: 30px;
    display: flex;
    align-items: center;
    padding: 0 7px;
    margin: 28px auto 0;
  }
  .top_button_djd_A {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #1b2336;
    cursor: pointer;
    border-radius: 30px;
    height: 32px;
    width: max-content;
    line-height: 32px;
    padding: 0 20px;
    margin-right: 10px;
  }

  .jcdjB {
    color: #100043;
    font-size: 14px;
    text-align: left;
    margin-top: 4px;
    font-weight: 400;
    font-family: SourceHanSansCN-Regular;
  }
  .jcdjC {
    color: #ff6c01;
    font-size: 14px;
    text-align: left;
    margin-top: 4px;
    font-weight: 400;
    font-family: SourceHanSansCN-Regular;
  }
  .div_jiajian_butt_text_B {
    height: 16px;
    background: #edf3fc;
    border-radius: 2px;
    border: 1px solid #ff6c01;
    display: inline-block;
    padding: 0 5px;
    font-size: 12px;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    color: #ff6c01;
    width: max-content;
    line-height: 16px;
    transform: translateY(-4px);
    margin-left: 10px;
  }
  .div_jiajian_butt_text_C {
    transition: 0.4s;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    width: 300px;
    text-transform: uppercase;
    margin-bottom: 31px;
  }
  .edcz_butt {
    width: 120px;
  }
  .cptc_butt {
    width: 120px;
  }
  .pay_main_body_divC_main {
    margin-bottom: 500px;
  }
  .pay_main_body_divC_main_div {
    width: 1400px;
    height: 200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .pay_main_body_divC_main_div_divA {
    width: 70%;
    height: 100%;
  }
  .pay_main_body_divC_main_div_divB {
    width: 30%;
    height: 100%;
  }
  .pay_main_body_divC_main_div_divA_div_div_input {
    display: flex;
    justify-content: space-between;
  }
  .pay_main_body_divC_main_div_divA_div_div_input_div {
    display: flex;
    justify-content: left;
  }
  .package-container {
    margin-top: 20px;
  }

  .package-button {
    margin: 10px;
    background: none; /* 无背景颜色 */
    border: none; /* 无边框 */
    padding: 10px 20px; /* 按钮内边距 */
    font-size: 19px; /* 字体大小 */
    font-weight: 600;
    cursor: pointer; /* 鼠标悬浮时显示为手型 */
    transition: color 0.3s ease; /* 文字颜色变化的过渡效果 */
    color: #0d0c3b;
  }

  .package-button:hover {
    color: #409eff; /* 鼠标悬浮时的文字颜色 */
  }

  .package-button.active {
    color: #409eff; /* 选中时的文字颜色 */
  }

  .shadow {
    width: 100%; /* 阴影宽度 */
    height: 5px; /* 阴影高度 */
    background: rgba(0, 0, 0, 0.2); /* 阴影颜色 */
    margin-top: 10px; /* 阴影与按钮的间距 */
  }
  .input_5 {
    width: 200px;
    margin-top: 38px;
  }
  .div_4 {
    display: flex;
    justify-content: center;
    height: 600px;
    overflow: hidden;
    overflow-y: auto;
  }
  .div_4 > div {
    margin-top: 50px;
    width: 1400px;
  }
  .H_qq {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 30px;
    color: #292626;
    width: 100px;
    background: #edf3fc;
    text-align: left;
    margin-top: 30px;
    margin-bottom: 30px;
    white-space: nowrap;
  }
  .a_text {
    position: relative;
    display: inline-block;
    padding: 8px;
    text-align: left;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    max-width: 214px;
    height: 56px;
    box-sizing: border-box;
    border-radius: 10px;
    background: #f8fbff;
    border: 1px solid #a0c1f7;
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 20px;
  }
  .retop_img {
    position: absolute;
    top: -8px;
    right: -11px;
    transform: rotate(-10deg);
  }
  .a_texttype {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 20px;
    color: #13497f;
  }
  .duoxuan {
  }
  .pay_main_body_divC_main_div_divB_divB_div_div_top {
  }
  .pay_main_body_divC_main_div_divB_divB_div_div_top > div:nth-child(1) {
    margin-top: 6px;
    font-family: SourceHanSansCN-Bold;
    font-size: 18px;
    color: #18195a;
  }
  .pay_main_body_divC_main_div_divB_divB_div_div_top > div:nth-child(2) {
    font-size: 14px;
    color: #6327d3;
    font-family: SourceHanSansCN-Medium;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
  }
  .pay_div_div_inputs {
    height: 400px;
    overflow: hidden;
    overflow-y: auto;
    margin-bottom: 20px;
  }
  .div_inputs {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .div_inputs > div {
    font-size: 18px;
    margin-right: 10px;
    color: #100043;
    width: 80px;
    font-size: 14px;
    text-align: left;
  }
  .div_inputs > div:nth-child(1) {
    height: 10px;
  }
  .div_inputs > div:nth-child(3) > .el-input-number {
    width: 100px;
    /* margin-top: -5px; */
  }
  .pay_div_div_nums {
    width: 270px;
    margin: 0 auto;
  }
  .pay_div_div_nums > div {
    margin-top: 10px;
  }
  .pay_div_div_nums > div:nth-child(1) {
    text-align: right;
    font-weight: 400;
    font-size: 12px;
    color: #000;
    align-items: center;
    cursor: pointer;
  }
  .pay_div_div_nums > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
  }
  .pay_div_div_nums > div:nth-child(3) {
    display: flex;
    justify-content: space-between;
    font-family: SourceHanSansCN-Regular;
    font-weight: 600;
    font-size: 16px;
    color: #1b2336;
  }
  .pay_div_div_nums > div:nth-child(4) {
    width: 100%;
    padding: 10px 0 10px 0;
    line-height: 0.889rem;
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    border-radius: 100px;
    background: linear-gradient(152deg, #6327d3 11%, #1b132b);
    font-family: SourceHanSansCN-Medium;
    color: #edf3fc;
  }
  .pay_div_div_nums > div:nth-child(5) {
    text-align: center;
    font-size: 12px;
    margin-bottom: 10px;
    color: rgba(27, 35, 54, 0.68);
  }
  .jia_jian_div {
    display: flex;
    justify-content: space-around;
    padding: 2px 0px 2px 0px;
    border: 1px solid #bdbdbd;
    border-radius: 20px;
  }

  .div_inputs_jian {
    padding: 0 5px 0 5px;
  }
  .div_inputs_input {
    padding: 0 10px 0 10px;
  }
  .div_inputs_jia {
    padding: 0 5px 0 5px;
  }
  </style>


